export const MERGE_FIELD_CATEGORY = {
  CONTACT: 'Contact',
  LOANS: 'Loan',
  OTHER: 'Other',
  INSURANCE: 'Insurance',
};
